/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyServiceNowIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-servicenow" */ './utils').then((m) => m.ServiceNowIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/servicenow/icon' },
);

const LazyServiceNowSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-servicenow-search-result" */ './utils').then(
			(m) => m.ServiceNowSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/servicenow/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ServiceNowIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyServiceNowIconComponent />
	</Suspense>
);

export const ServiceNowSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyServiceNowSearchResultIconComponent />
	</Suspense>
);
